import React from 'react'

function Footer() {
  return (
    <div className='footer'>
       <h4>Helpline number : +91-8957090508 , +91-7579099688</h4> 
    </div>
  )
}

export default Footer